<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" :persistent="loading">
      <v-card>
        <v-card-title class="headline">
          Agregar Nota
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
             
        <v-card-text class="pt-4">
          <v-textarea
            v-model="noteText"
            placeholder="Escribe aquí..."
            outlined
            rows="8"
            auto-grow
            counter="500"
            maxlength="500"
            no-resize
          />
        </v-card-text>
             
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeModal"
            :disabled="loading"
          >
            Cancelar
          </v-btn>
          <v-btn
            v-if="can('users:update')"
            color="primary"
            :loading="loading"
            @click="saveNote"
          >
            {{ existingNote ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api360Service from '../services/360.service.js';
import { can } from '../utils/permissions';

export default {
  name: 'AddNoteModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => ({})
    },
    existingNote: {
      type: String,
      default: ''
    },
    // Token del administrador. Antes se leía de `$parent.$parent`, que dejó de ser la vista 360
    // al mover el modal al contenedor (113-user-360-redesign).
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      noteText: '',
      loading: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.noteText = this.existingNote || ''
      }
    }
  },
  methods: {
    can,
    closeModal() {
      this.dialog = false
      this.noteText = ''
    },
    
    async saveNote() {
      this.loading = true;
      
      try {
        await Api360Service.updateUserNote(
          this.userInfo.userId,
          this.noteText,
          this.token
        );
        
        this.$emit('note-saved', {
          note: this.noteText,
          userId: this.userInfo.userId
        });
        
        this.closeModal();
        
      } catch (error) {
        // Handle error silently
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.headline {
  font-size: 1.25rem !important;
  font-weight: 500;
  color: #1b1d21;
}

.v-card {
  border-radius: 8px;
}
</style>